// @ts-check

import * as _ from 'lodash-es'

/**
 * Returns keys with a truthy value from the given object.
 * @param {Parameters<typeof _.pickBy>[0]} obj
 */
export const pickTruthy = (obj) => _.keys(_.pickBy(obj))

/**
 * Returns an array of ids from the given id map object.
 * @param {Parameters<typeof _.pickBy>[0]} obj
 */
export const pickSelectedIds = (obj) =>
  pickTruthy(obj).map((id) => (Number.isNaN(+id) ? id : +id))

/**
 * Returns true if the given value is numeric.
 * @param {*} value
 */
export const isNumeric = (value) => /^[+-]?\d+(\.\d+)?$/.test(value)

/**
 * Returns the given value if it is a number, otherwise returns the given default value.
 * @param {*} value
 * @param {*} defaultValue
 * @returns
 */
export const numberOrDefault = (value, defaultValue) =>
  isNumeric(value) ? value : defaultValue

/**
 * @template T
 * @param {T[]} array - The array to be modified.
 * @param {T} obj - The object to be added or modified in the array.
 * @param {keyof T} field - The field to be used for identifying the object in the array.
 * @returns {T[]} The modified array.
 */
export const addOrUpdate = (array, obj, field) => {
  const index = _.findIndex(array, [field, obj[field]])
  if (index === -1) {
    return _.concat(array, obj)
  }
  return _.set(array, index, obj)
}
